var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVmInformation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 14.5V12.5C2.5 11.9696 2.71071 11.4609 3.08579 11.0858C3.46086 10.7107 3.96957 10.5 4.5 10.5H16.5C17.0304 10.5 17.5391 10.7107 17.9142 11.0858C18.2893 11.4609 18.5 11.9696 18.5 12.5V14.5C18.5 15.0304 18.2893 15.5391 17.9142 15.9142C17.5391 16.2893 17.0304 16.5 16.5 16.5H4.5C3.96957 16.5 3.46086 16.2893 3.08579 15.9142C2.71071 15.5391 2.5 15.0304 2.5 14.5Z",
    stroke: "#16151C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 13.5C6.5 13.2348 6.39464 12.9804 6.20711 12.7929C6.01957 12.6054 5.76522 12.5 5.5 12.5C5.23478 12.5 4.98043 12.6054 4.79289 12.7929C4.60536 12.9804 4.5 13.2348 4.5 13.5C4.5 13.7652 4.60536 14.0196 4.79289 14.2071C4.98043 14.3946 5.23478 14.5 5.5 14.5C5.76522 14.5 6.01957 14.3946 6.20711 14.2071C6.39464 14.0196 6.5 13.7652 6.5 13.5Z",
    fill: "#16151C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 8.494L2.51 6.494C2.51159 5.96461 2.723 5.45744 3.0979 5.08366C3.4728 4.70989 3.98061 4.5 4.51 4.5H16.5C17.0044 4.50009 17.4901 4.69077 17.8599 5.03384C18.2297 5.3769 18.4562 5.84702 18.494 6.35L18.5 6.506L18.49 8.506C18.4884 9.03539 18.277 9.54256 17.9021 9.91634C17.5272 10.2901 17.0194 10.5 16.49 10.5H4.5C3.99542 10.5002 3.50943 10.3096 3.13945 9.9665C2.76947 9.62341 2.54284 9.15315 2.505 8.65L2.5 8.494Z",
    stroke: "#16151C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 7.5C6.5 7.23478 6.39464 6.98043 6.20711 6.79289C6.01957 6.60536 5.76522 6.5 5.5 6.5C5.23478 6.5 4.98043 6.60536 4.79289 6.79289C4.60536 6.98043 4.5 7.23478 4.5 7.5C4.5 7.76522 4.60536 8.01957 4.79289 8.20711C4.98043 8.39464 5.23478 8.5 5.5 8.5C5.76522 8.5 6.01957 8.39464 6.20711 8.20711C6.39464 8.01957 6.5 7.76522 6.5 7.5Z",
    fill: "#16151C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVmInformation);
export default __webpack_public_path__ + "static/media/vm-information.0f7a17ea1a23b98cb97160d45dda64be.svg";
export { ForwardRef as ReactComponent };